import gql from 'graphql-tag';
import Interface from '../Interface';

interface RegisterChildSessionInput {
  childSessionId: string;
  contentId?: string;
  roomId?: string;
  version?: number;
}

export default class ChildSessionInterface extends Interface {
  public async registerSession(input: RegisterChildSessionInput) {
    return this.mutate<null>(async () => {
      const response = await this.apolloService.executeMutation({
        mutation: gql`
          mutation registerChildSession($input: RegisterChildSessionInput!) {
            registerChildSession(input: $input) {
              errors
            }
          }
        `,
        variables: {
          input,
        },
      });

      return {
        data: null,
        serverErrors: response.errors,
        serverMessage: response.errors?.map((e) => e.message).join(''),
      };
    }, 'Error registering child session');
  }
}
